import baseAjaxConfig from 'actions/BaseAjaxConfig';
import ApiCaller from 'actions/ApiCaller';
import { DeferredContent } from 'actions/deferredContentAction';
export const TNC_URL = '/api/1/exchange/tnc';
const ActionName = 'FETCH_REVERSE_LISTING_MORE_INFO';
// This action is slightly different from the basic deferred content module.
// But reusing all those actions to avoid too much reducer boiler plate to
// store a json blob
export function fetchKnowMoreAction({ params }) {
    const url = TNC_URL;
    return dispatch => {
        dispatch({ type: DeferredContent.DEFERRED_CONTENT_REQUEST, url });
        const settings = Object.assign({}, baseAjaxConfig, {
            pathname: url,
            action: ActionName
        });
        return ApiCaller.post(settings, params).then(data => dispatch({ type: DeferredContent.DEFERRED_CONTENT_SUCCESS, url, content: data.RESPONSE }), err => dispatch({ type: DeferredContent.DEFERRED_CONTENT_ERROR, url, err }));
    };
}
